export const TOASTIFY_MSG = {
  LOCATION: {
    CREATE: 'Location created successfully.',
    EDIT: 'Location details successfully updated.'
  },
  PAYMENT_METHOD: {
    ADD_EDIT_SUCCESS: 'Payment method successfully updated',
    ADD_EDIT_FAILED: (error: any) => `Payment method failed to update. Error: ${error}`,
    SAVE_SUCCESS: 'Save changes successfully',
    SAVE_FAILED: (error: any) => `Save changes failed. Error: ${error}`
  },
  USER: {
    CREATE: 'User created successfully.',
    EDIT: 'User details successfully updated.'
  },
  IMAGE: {
    LIMIT_SIZE_KB: (size: number) => `Please choose a jpg or png image of ${size} KB or less`,
    LIMIT_EXTENSION: 'Please choose an jpg or png image.'
  },
  PASSWORD_UPDATE: {
    SUCCESS: 'Password successfully updated.',
    FAILED: (error: string) => `${error} !!!`
  },
  CLIENT: {
    LOAD_FAIL: (name: string, error: string) => `Cannot load ${name} field's values. ${error}`,
    UPDATING: 'Client setting updating',
    UPDATE_SUCCESS: 'Client setting updated successfully',
    UPDATE_FAIL: 'Fail to update. Something is wrong'
  },
  CLIENT_CONTACT: {
    CREATE: 'Client contact created successfully.',
    EDIT: 'Client contact successfully saved.'
  },
  OTHER_CONTACT: {
    CREATE: 'Other contact created successfully.',
    EDIT: 'Other contact successfully saved.'
  },
  BUSINESS: {
    CREATE: 'Business created successfully.',
    EDIT: 'Business successfully saved.'
  },
  CHASE: {
    CHASE_SENT: 'Chase sent successfully.',
    CHASE_CANCELLED: 'Chase cancelled successfully.',
    CHASE_SENT_FAILED: 'An error occured when sending the chase.',
    CHASE_CANCEL_FAILED: 'An error occured when cancelling the chase.'
  },
  CLIENT_CONTACT_DETAIL: {
    ANONYMISE_DATA_SUCCESS: 'Anonymise data successfully.',
    ANONYMISE_DATA_FAILED: (name: string) => `Anonymise data of ${name} failed.`,
    EXPORT_DATA_SUCCESS: 'Export data successfully.',
    EXPORT_DATA_FAILED: (name: string) => `Export data for ${name} falied.`,
    ADD_MEMO_SUCCESS: 'Add memo successfully.',
    ADD_MEMO_FAILED: 'Add memo failed.',
    EDIT_MEMO_SUCCESS: 'Memo edited successfully.',
    EDIT_MEMO_FAILED: 'Memo edited failed.',
    DELETE_MEMO_SUCCESS: 'Memo deleted successfully.',
    DELETE_MEMO_FAILED: 'Memo deleted failed.',
    SEND_EMAIL_SUCCESS: 'Email has been sent successfully.',
    SEND_EMAIL_FAILED: 'Email could not be sent, please check subject and message are filled in.',
    SEND_SMS_SUCCESS: 'SMS has been sent successfully.',
    SEND_SMS_FAILED: (error: string) => `SMS has not be sent. Error: ${error}`,
    CREATE_INVOICE_FAIL: 'Failed to create invoice. Something went wrong.'
  },
  SECURITY: {
    UPDATE_SUCCESS: 'Security setting updated successfully'
  },
  SERVICE: {
    CREATE: 'Service created successfully.',
    EDIT: 'Service details successfully updated.',
    SAVED: 'Service details successfully saved.'
  },
  ONLINE_BOOKING: {
    UPDATE_SUCCESS: 'Online booking setting updated successfully',
    COPY_TO_CLIPBOARD: 'Copied to clipboard!',
    EMAIL_INVALID: 'The email address is invalid'
  },
  BUSINESS_PROFILE_UPDATE: {
    SUCCESS: 'Business profile successfully updated.',
    FAILED: (error: string) => `${error} !`
  },
  APPOINTMENT_BOOKING: {
    SUCCESS: 'Appointment Booked Successfully',
    UPDATE: 'Appointment Updated Successfully',
    FAILED: (error: string) => `${error} !`
  },
  EVENT_BOOKING: {
    SUCCESS: 'Event saved successfully',
    FAILED: (error: string) => `${error} !`
  },
  AVAILABILITY_BOOKING: {
    SUCCESS: 'Availability saved successfully',
    FAILED: (error: string) => `${error} !`
  },
  SMS_NOTIFICATION: {
    ENABLE_SUCCESS: 'SMS Notification is successfully enabled.',
    ENABLE_FAIL: 'SMS Notification failed to enabled.'
  },
  PRONTO_REFERRAL_SETTING: {
    SUCCESS: 'Pronto referral setting successfully updated.'
  },
  PRONTO_REPORT: {
    SAVE_DRAFT: {
      SUCCESS: 'Report is saved draft successfully.',
      FAILED: 'Save draft failed.'
    },
    SUBMIT: {
      SUCCESS: 'Report is submitted successfully.',
      FAILED: 'Report is submitted failed.'
    }
  },
  REFERRAL_SIGNUP: {
    SUCCESS: 'Account created successfully.',
    FAILED: 'Something went wrong.'
  },
  SAVING: 'Saving...',
  SAVED: 'Changes saved successfully',
  ERROR: 'Cannot save. Please check screen for errors.',
  LOAD_ERROR: 'Cannot load. Please try again later.',
  DATA_EXTRACT: {
    SCHEDULED:
      "Your data extract has been scheduled sucessfully, we'll let you know you when its ready."
  },
  EMAIL: {
    SENDING: 'Sending email...',
    SUCCESS: 'Email has been sent successfully.',
    FAILED: 'Email has not sent. Something went wrong.'
  },
  SMS: {
    SENDING: 'Sending SMS...',
    SUCCESS: 'SMS has been sent successfully.',
    FAILED: 'SMS has not sent. Something went wrong.'
  },
  PAYMENT: {
    REFUND: {
      SUCCESS: 'Refund successful',
      FAILED: 'Refund failed'
    }
  },
  UPGRADE: {
    SUCCESS: 'You have been sucessfully upgraded to Click Plus.',
    FAILED: 'Something went wrong. Please contact us for assistance.'
  },
  DOWNGRADE: {
    SUCCESS: 'You have been sucessfully downgraded to Click Free.',
    FAILED: 'Something went wrong. Please contact us for assistance.'
  },
  TRIAL: {
    SUCCESS: 'You have started your 30 day free trial.',
    FAILED: 'Something went wrong. Please contact us for assistance.'
  },
  SCORES: {
    VALIDATION: 'Validation Failed. Please check values.'
  },
  GOALS: {
    EXISTS: 'This Goal already exists. Please try adding a different Goal.'
  }
};
